<template>
	<SectionCard>
		<template #title>
			{{ elementType.cardTitle }}
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="6">
					<TextField
						label="Default Content"
						disabled
						:test-id="`${element.name}_default_content`"
						:value="element.content"
					/>
				</v-col>
				<v-col cols="6">
					<TextField
						label="Translated Content"
						:value.sync="translatedContent"
						:disabled="!userFullPermissions"
						:test-id="`${element.name}_translated_content`"
						@input="updateTranslation(element.name, 'content', $event)"
					/>
				</v-col>
			</v-row>
		</template>
	</SectionCard>
</template>

<script>
import SectionCard from '../../../../../../shared/components/section-card.vue'
import TextField from '../../../../../../shared/components/text-field.vue'
export default {
	components: {
		SectionCard,
		TextField
	},
	props: {
		element: {
			type: Object,
			required: true
		},
		elementType: {
			type: Object,
			required: true
		},
		translatedSchema: {
			type: Object,
			required: true
		},
		userFullPermissions: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		translatedContent () {
			return this.translatedSchema[this.element?.name]?.content
		}
	},
	methods: {
		updateTranslation (key, property, value) {
			this.$emit('update-translation', key, property, value)
		}
	}
}
</script>
